// extracted by mini-css-extract-plugin
export default {"menu":"ActionsPopup_menu__RMa6F","menuItem":"ActionsPopup_menuItem__AoYzh"};